import {
  Button,
  ClickAwayListener,
  Drawer,
  FormControl,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Popper,
  Select,
  TextField,
  makeStyles,
} from "@material-ui/core";
import React, { useState, useRef } from "react";
import "./gridControls.scss";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import CloseIcon from "@material-ui/icons/Close";
import OverflowComponent from "./OverflowComponent";
import ValueDetail from "./ValueDetail";
import ValueDetailDDValue from "./ValueDetaiDDValue";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { update } from "lodash";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

const MultiValueLabels = ({
  dd,
  model,
  tab,
  searchPlaceHolderText,
  values,
  onCreate,
  onUpdate,
  onDelete,
  sortUpdate,
  sort,
  intl = null,
  fullLangCode = "",
  disabled = false,
}) => {
  const useStyles = makeStyles((theme) => ({
    itemContainer: {
      margin: "8px 0",
      alignItems: "center",
      "&:hover": {
        backgroundColor: "#F3FAFF;",
      },
    },
  }));
  const classes = useStyles();
  const dragRef = useRef();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const [over, setOver] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = (event) => {
    if (tab === "DD-Values") {
      if (isDrag) {
        sortUpdate(finalMenuList);
        setIsDrag(false);
      }
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popId = open ? "simple-popper" : undefined;
  const [finalMenuList, setFinalMenuList] = useState(values);
  const onSearchOptions = (e) => {
    const { value } = e.target;
    if (e.key === "Enter" && value.trim() !== "") {
      const fieldValues = value.split(",");
      const fieldValueMenuList = [];
      fieldValues.forEach((f) => {
        fieldValueMenuList.push({ name: f, description: "" });
      });
      setFinalMenuList([...finalMenuList.concat(fieldValueMenuList)]);
      e.target.value = "";
      if (tab === "DD-Values") {
        for (let i = 0; i < fieldValueMenuList.length; i++) {
          let name = fieldValueMenuList[i]?.name;
          let desc = fieldValueMenuList[i]?.description;
          let sortNo = finalMenuList.length + i + 1;
          onCreate(model, dd, name, desc, sortNo);
        }
      }
    }
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    const items = Array.from(finalMenuList);
    const [reorderedItem] = items.splice(droppedItem.source.index, 1);
    items.splice(droppedItem.destination.index, 0, reorderedItem);
    setFinalMenuList(items);
     sortUpdate(items);
    setIsDrag(true);
  };

  const removeItem = (item) => {
    setFinalMenuList([
      ...finalMenuList.filter((listValue) => item !== listValue),
    ]);
    if (tab === "DD-Values") {
      onDelete(model, dd, item?.id);
    }
  };

  const handleDots = (i) => {
    const list = [...finalMenuList];
    list.map((item, index) => {
      if (i === index) {
        item.enable = true;
      } else {
        item.enable = false;
      }
    });
    setFinalMenuList(list);
  };

  return (
    <div
      className="contained-grid-container"
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? "0.4" : "1",
      }}
    >
      {typeof values === "string" && injectIntlTranslation(intl, "NA", "NA")}
      {typeof values === "object" && (
        <OverflowComponent
          onClick={(e) => {
            if (!disabled) {
              handleClick(e);
            }
            setDrawerOpen(true);
          }}
          items={finalMenuList?.map((e) => e.name)}
        />
      )}

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
        }}
      >
        <div
          style={{
            width: "700px",
            background: "#ffffff",
            height: "100vh",
            overflow: "hidden",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              height: "324px",
              width: "100%",
              border: "1px none #fffff",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              padding: "5px",
            }}
          >
            <div
              style={{
                padding: "5px 5px 10px 5px",
                borderBottom: "1px solid gray",
                position: "fixed",
                top: "0px",
                background: "#ffffff",
                width: "100%",
                zIndex: 2,
              }}
            >
              <div style={{ marginBottom: "5px" }}>
                <b>Config Name:</b> {dd?.configGroup?.name}
              </div>
              <div>
                <b>DD Name:</b> {dd?.ddName}
              </div>
            </div>
            <Grid xs={12} container>
              <Grid
                item
                container
                style={{
                  paddingTop: "10px",
                  background: "#fff",
                  position: "sticky",
                  top: "54px",
                  zIndex: 2,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#D1E9FD",
                    borderBottom: "1px solid #D1E9FD",
                    width: "100%",
                  }}
                >
                  <TextField
                    fullWidth
                    variant="standard"
                    style={{ fontSize: "12px", padding: "3px 10px" }}
                    placeholder={searchPlaceHolderText}
                    onKeyUp={onSearchOptions}
                  ></TextField>
                </div>
              </Grid>
              <Grid
                item
                container
                xs={12}
                spacing={0}
                style={{ paddingTop: "60px", paddingBottom: "50px" }}
              >
                <div ref={dragRef} style={{ width: "100%" }}>
                  <DragDropContext onDragEnd={handleDrop}>
                    <Droppable droppableId={`finalMenuList`}>
                      {(provided) => (
                        <div
                          className="menu-list"
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {!!finalMenuList?.length &&
                            finalMenuList?.map((item, index) => {
                              return (
                                <Draggable
                                  id={item?.id}
                                  key={item?.id}
                                  draggableId={`${item?.id}`}
                                  index={index}
                                >
                                  {(provided2) => (
                                    <Grid
                                      key={index}
                                      onMouseOver={() => handleDots(index)}
                                      item
                                      xs={12}
                                      container
                                      className={classes.itemContainer}
                                      ref={provided2.innerRef}
                                      {...provided2.draggableProps}
                                      {...provided2.dragHandleProps}
                                    >
                                      <Grid item xs={12} spacing={0}>
                                        <div
                                          style={{
                                            display: "flex",
                                            padding: "6px",
                                            width: "97%",
                                            gap: "8px",
                                            alignItems: "center",
                                          }}
                                        >
                                          <DragIndicatorIcon
                                            className="grid-action-item-multi"
                                            style={{
                                              cursor: "move",
                                            }}
                                            fontSize="small"
                                          />

                                          <ValueDetailDDValue
                                            valueName={injectIntlTranslation(
                                              intl,
                                              item.name,
                                              item.name
                                            )}
                                            description={injectIntlTranslation(
                                              intl,
                                              item.description,
                                              item.description
                                            )}
                                            onUpdate={onUpdate}
                                            model={model}
                                            dd={dd}
                                            tab={tab}
                                            ddValueId={item?.id}
                                            item={item}
                                            sort={item?.sort}
                                            fullLangCode={fullLangCode}
                                          />
                                          <CloseIcon
                                            style={{
                                              paddingLeft: "4px",
                                              color: "#BAC0D0",
                                              cursor: "pointer",
                                            }}
                                            fontSize="small"
                                            onClick={() => removeItem(item)}
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                  )}
                                </Draggable>
                              );
                            })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </Grid>
            </Grid>

            {/* <div
              style={{
                width: "700px",
                background: "#ffffff",
                position: "fixed",
                bottom: "0px",
                padding: "5px",
                textAlign: "center",
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  sortUpdate(finalMenuList);
                }}
                disabled={false}
                className={classes.saveButton}
              >
                Save
              </Button>
            </div> */}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default injectIntl(MultiValueLabels);
